import type { QueryClient } from "@tanstack/react-query";
import {
	appendConfirmedChatMessage,
	replaceOptimisticChatMessage,
} from "web_myplann/Chat/Helpers/Messages/chatMessagesCache";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

export const confirmOptimisticChatMessage = (
	queryClient: QueryClient,
	conversationId: number | null,
	clientId: string,
	message: ChatMessageView,
) => {
	if (
		!replaceOptimisticChatMessage(
			queryClient,
			conversationId,
			clientId,
			message,
		)
	) {
		appendConfirmedChatMessage(queryClient, conversationId, message);
	}
};
